import React from "react";
const AppContext = React.createContext(null);
export const AppProvider = AppContext.Provider;
export default AppContext;
